import React, { useState, useEffect } from "react";
import { FaXmark } from "react-icons/fa6";
import SelectBox from "../reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";
import {
  useEditRelationMutation,
  useGetTableColumnsMutation,
} from "./JoinTableApiSlice";

export default function TableRelationModal({
  closeModal,
  joinObject,
  setJoinObject,
  handleTableSelection,
  joinFunction,
  joinData,
  isJoinLoading,
  isJoinError,
  isJoinSuccess,
  joinError,
  isEdit,
  editJoinFunction,
  editRelationData,
  isEditRelationError,
  isEditRelationLoading,
  isEditRelationSuccess,
  editRelationError,
}) {
  // console.log(joinObject);
  const [baseTableColumns, setBaseTableColumns] = useState([]);
  const [newTableColumns, setNewTableColumns] = useState([]);
  const [isCustomSQL, setIsCustomSQL] = useState(false);
  const [message, setMessage] = useState("");
  // console.log(message);
  // Fetch columns
  const [
    getTableColumns,
    {
      data: tableColumns,
      isError: isTableColumnsError,
      isLoading: isTableColumnsLoading,
      isSuccess: isTableColumnsSuccess,
      error: tableColumnsError,
    },
  ] = useGetTableColumnsMutation();

  useEffect(() => {
    const fetchTableColumns = async () => {
      if (
        joinObject["baseTableName"] &&
        joinObject["newTableName"] &&
        joinObject["newTableDatabase"]
      ) {
        const object = {
          database: joinObject["newTableDatabase"],
          baseTableName: joinObject["baseTableName"],
          newTableName: joinObject["newTableName"],
        };

        const response = await getTableColumns(object);
        function modifiedArray(array) {
          const modifiedArray = array.map((db) => {
            return {
              label: db,
              value: db,
            };
          });
          return modifiedArray;
        }
        const baseTable =
          response["data"]["response"][joinObject["baseTableName"]];
        const newTable =
          response["data"]["response"][joinObject["newTableName"]];
        if (Array.isArray(baseTable) && Array.isArray(newTable)) {
          setBaseTableColumns(modifiedArray(baseTable));
          setNewTableColumns(modifiedArray(newTable));
        }
      } else {
        console.error(
          `baseTableName, newTableName, newTableDatabase should be defined`
        );
      }
    };
    fetchTableColumns();
  }, []);

  if (isTableColumnsError) {
    // console.log(tableColumnsError);
  }

  const joinTypes = [
    { label: "Left", value: "left" },
    { label: "Inner", value: "inner" },
    { label: "Right", value: "right" },
    { label: "Full", value: "full" },
  ];

  const handleBaseTableCoumn = (e) => {
    const selected = baseTableColumns.find(
      (item) => item.value === e.target.value
    );
    if (selected) {
      setJoinObject((prev) => ({ ...prev, baseColumnName: selected.value }));
    }
  };
  const handleNewTableCoumn = (e) => {
    const selected = newTableColumns.find(
      (item) => item.value === e.target.value
    );
    if (selected) {
      setJoinObject((prev) => ({ ...prev, newColumnName: selected.value }));
    }
  };
  const handleJionType = (e) => {
    const selected = joinTypes.find((item) => item.value === e.target.value);
    if (selected) {
      setJoinObject((prev) => ({ ...prev, joinType: selected.value }));
    }
  };
  const handleTextAreaChange = (e) => {
    if (e.target.value) {
      setJoinObject((prev) => ({ ...prev, customSQL: e.target.value }));
    }
  };

  const handleFinalFunctionCall = (isEdit) => {
    if (isEdit) {
      editJoinFunction(joinObject);
      closeModal();
    } else {
      function getNullOrUndefinedInfo(obj) {
        const nullOrUndefinedKeys = Object.entries(obj)
          .filter(
            ([key, value]) =>
              key !== "customSQL" && (value === null || value === undefined)
          )
          .map(([key]) => key);

        return {
          hasNullOrUndefined: nullOrUndefinedKeys.length,
          keysWithNullOrUndefined: nullOrUndefinedKeys,
        };
      }
      const { hasNullOrUndefined, keysWithNullOrUndefined } =
        getNullOrUndefinedInfo(joinObject);
      if (!hasNullOrUndefined) {
        joinFunction(joinObject);
        closeModal();
      } else {
        setMessage(
          `Please fill out the following fields: ${keysWithNullOrUndefined.join(
            ", "
          )}`
        );
        return;
      }
    }
  };

  return (
    <main className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <section
        className={`flex flex-col bg-white shadow-2xl rounded w-full max-w-lg justify-between items-center gap-4`}
      >
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg  font-medium">
          Relationship b/w [{joinObject["baseTableName"]}] with [
          {joinObject["newTableName"]}]
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        {isTableColumnsLoading ? (
          <p className="w-full text-start font-medium">
            table columns are loading...
          </p>
        ) : isTableColumnsError ? (
          <p className="w-full text-start font-medium text-red-500">
            an error occured while loading the table columns
          </p>
        ) : null}

        <div className="w-full flex items-start justify-center gap-2 px-2">
          <div className="w-1/2 flex flex-col items-start justify-start">
            <span className="font-medium">
              {joinObject["baseTableName"]} Columns
            </span>
            <SelectBox
              value={joinObject["baseColumnName"]}
              optionsArray={baseTableColumns}
              onChange={handleBaseTableCoumn}
              isArrayBig={baseTableColumns.length > 6}
            />
          </div>
          <div className="w-1/2 flex flex-col items-start justify-start">
            <span className="font-medium">
              {joinObject["newTableName"]} Columns
            </span>
            <SelectBox
              value={joinObject["newColumnName"]}
              optionsArray={newTableColumns}
              onChange={handleNewTableCoumn}
              isArrayBig={newTableColumns.length > 6}
            />
          </div>
        </div>
        <div className="w-full flex flex-col items-start justify-start px-2">
          <span className="font-medium">Join Type</span>
          <SelectBox
            value={joinObject["joinType"]}
            optionsArray={joinTypes}
            onChange={handleJionType}
            isArrayBig={joinTypes.length > 6}
          />
        </div>
        <button className="cursor-pointer flex items-center mb-1 w-full truncate font-light px-2">
          <input
            type="checkbox"
            id={`customSQL`}
            // value={option}
            checked={isCustomSQL}
            onChange={() => setIsCustomSQL(!isCustomSQL)}
            className="mr-[6px] checkbox-input cursor-pointer"
          />
          <label
            htmlFor={`customSQL`}
            className="truncate w-full text-left cursor-pointer font-medium"
          >
            Cusomt SQL
          </label>
        </button>
        <div className="w-full px-2">
          <textarea
            id="formula"
            name="formula"
            value={joinObject["customSQL"]}
            onChange={handleTextAreaChange}
            placeholder="Type your SQL formula here..."
            disabled={!isCustomSQL}
            className={`border rounded px-2 py-1 h-auto w-full text-xs font-medium focus:outline-none resize-none ${
              !isCustomSQL ? "bg-gray-100 cursor-not-allowed" : ""
            }`}
            style={{ minHeight: "6rem" }}
          />
        </div>
        <footer className="flex justify-end items-center w-full p-2 bg-gray-50 gap-x-4">
          <div className="text-sm text-left w-full space-y-1">
            {/* Loading Messages */}
            {(isEditRelationLoading ||
              isJoinLoading ||
              isTableColumnsLoading) && (
              <div className="text-yellow-500 font-medium">
                {isEditRelationLoading && <p>Updating the join...</p>}
                {isJoinLoading && <p>Creating the join...</p>}
                {isTableColumnsLoading && <p>Table columns are loading...</p>}
              </div>
            )}

            {/* Error Messages */}
            {(isEditRelationError || isJoinError || isTableColumnsError) && (
              <div className="text-red-500 font-medium">
                {isEditRelationError && (
                  <p>An error occurred while updating the join.</p>
                )}
                {isJoinError && (
                  <p>An error occurred while creating the join.</p>
                )}
                {isTableColumnsError && (
                  <p>An error occurred while loading the table columns.</p>
                )}
              </div>
            )}

            {/* Success Messages */}
            {(isEditRelationSuccess || isJoinSuccess) && (
              <div className="text-green-500 font-medium">
                {isEditRelationSuccess && <p>Join updated successfully.</p>}
                {isJoinSuccess && <p>Join created successfully.</p>}
              </div>
            )}
            {/* message */}
            {message && (
              <div className="text-red-500 font-medium">{message}</div>
            )}
          </div>

          {/* Action Buttons */}
          <button
            className="border py-1 px-2 tracking-wide mr-2 text-gray-700 hover:bg-gray-200"
            onClick={closeModal}
          >
            Close
          </button>
          <button
            className="border py-1 px-2 tracking-wide bg-blue-950 text-white"
            onClick={() => handleFinalFunctionCall(isEdit)}
          >
            {isEdit ? "Edit Join" : "Join"}
          </button>
        </footer>
      </section>
    </main>
  );
}
